const MainRoutes = {
  HOME: "/",
  LOGIN: "/login",
  SIGNUP: "/signup",
  FORGOTPASSWORD: "/forgotpassword",
  PROFILE: "/profile",
  ALLCOMPLAINTS: "/allcomplaints",
  COMPLAINT_WITHOUT_RATING: "/complaint-without-rating",
  COMPLAINTDETAILS: "/complaintdetails",
  HELPDESK: "/helpdesk",
  CATEGORY: "/category",
  SUBCATEGORY: "/subcategory",
  SUBSUBCATEGORY: "/subsubcategory",
  AREA: "/area",
  APPROVAL: "/approval",
  COMPLAINT_REQUESTS: "/complaint-requests",
  NOTICE: "/notice",
  NOTICEDETAILS: "/noticedetails",
  DISCUSSION: "/discussion",
  DISCUSSIONDETAILS: "/discussiondetails",
  MEETING: "/meeting",
  MEETINGDETAILS: "/meetingdetails",
  POLL: "/poll",
  POLLDETAILS: "/polldetails",
  ADMIN: "/admin",
  MANAGER: "/manager",
  GROUP: "/group",
  USERS: "/users",
  USERDETAILS: "/usersdetails",
  MEMBER: "/member",
  ADDMEMBER: "/addmember",
  VENDOR: "/vendor",
  VENDORPROFILE: "/vendorprofile",
  VENDORRECYCLEBIN: "/vendorrecyclebin",
  VENDORREVIEW: "/vendorreview",
  SOCIETYMANAGE: "/societymanage",
  LEVELS: "/levels",
  LEVELDETAILS: "/leveldetails",
  LEVELDATA: "/leveldata",
  LEVELDATADETAILS: "/leveldatadetails",
  DIVISION: "/division",
  SOCIETYREQUESTS: "/societyrequests",
  DAILYHELP: "/dailyhelp",
  EMERGENCYNUMBER: "/emergencynumber",
  LOCALDIRECTORY: "/localdirectory",
  QUICKVIEW: "/quickview",
  ADMINAPPROVAL: "/adminapproval",
  ADMINDETAILS: "/admindetails",
  READWRITEACCESS: "/readwriteaccess",
  CONFIGURATION: "/configuration",
  GROUPING: "/grouping",
  GROUPINGDETAILS: "/groupingdetails",
  USERREQUEST: "/userrequest",
  ROLE: "/role",
  ROLEDETAILS: "/roledetails",
  COMPLAINTCONFIGURATION: "/complaintconfiguration",
  UNAUTHORIZED: "/accessdenied",
  COMPLAINTLEVELS: "/complaintlevels",
  ESCALATIONDETAILS: "/escalationdetails",
  DEADLINEAPPROVAL: "/approval",
  RATING: "/rating",
  ACTIVITY: "/activity",
  MISQUICKVIEW: "/mis-quickview",
  MISDETAILEDVIEW: "/mis-detailedview",
  TOKEN: "/token",
  ADDADVANCEVENDORSETTING: "/add-advance-vendor-setting",
  AllADVANCEVENDORSETTING: "/advance-vendor-setting",
  HELP_CENTER: "/help-center",
  ADDFAQ: "/add-faq",
  FAQDETAILS: "/faqdetails",
  ALLLOGS: "/alllogs",
  CONTACTBOOK: "/contactbook",
  CONTACTBOOKSUBCATEGORY: "/contactbooksubcategory",
  CONTACT: "/contact",
  MIS_COMPLAINT_DASHBOARD: "/mis-complaint-dashboard",
  MIS_LOCATION_ANALYTICS: "/mis-location-analytics",
  MIS_ASSIGNED_COMPLAINTS_REPORT: "/mis-assigned-complaints-report",
  MIS_CLOSED_COMPLAINTS_REPORT: "/mis-closed-complaints-report",
  MIS_CANCELLED_COMPLAINTS_REPORT: "/mis-cancelled-complaints-report",
  MIS_VENDOR_ANALYTICS: "/mis-vendor-analytics",
  MIS_SETTINGS: "/mis-settings",
  SURVEY_ANALYTICS: "/survey-analytics",
  SURVEY_LIST: "/survey-list",
  SURVEY_DETAILS: "/survey-details",
  SURVEY_BLOCK: "/survey-block-management",
  SURVEY_PANCHAYAT: "/survey-panchayat-management",
  SURVEY_VILLAGE: "/survey-village-management",
};

export default MainRoutes;
